// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-module__card-container__MBPNi {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.index-module__green__rcsVu {
  background-color: #0f5132;
  color: #fff;
}
.index-module__red__iU6qg {
  background-color: #842029;
  color: #fff;
}
@media (max-width: 674px) {
  .index-module__card-container__MBPNi {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ClientParkingAvailabilityList/index.module.less"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,SAAS;EACX;AACF","sourcesContent":[".card-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.green {\n  background-color: #0f5132;\n  color: #fff;\n}\n.red {\n  background-color: #842029;\n  color: #fff;\n}\n@media (max-width: 674px) {\n  .card-container {\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card-container": `index-module__card-container__MBPNi`,
	"green": `index-module__green__rcsVu`,
	"red": `index-module__red__iU6qg`
};
export default ___CSS_LOADER_EXPORT___;
